import { render, staticRenderFns } from "./quiz-question.vue?vue&type=template&id=196f6787&scoped=true&"
import script from "./quiz-question.vue?vue&type=script&lang=js&"
export * from "./quiz-question.vue?vue&type=script&lang=js&"
import style0 from "./quiz-question.vue?vue&type=style&index=0&id=196f6787&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f6787",
  null
  
)

export default component.exports